export default __webpack_public_path__ + "static/media/floating-icon.5d504358.ico";